import { render, staticRenderFns } from "./AdminOrdersSubMenusLinks.vue?vue&type=template&id=2543c05a"
import script from "./AdminOrdersSubMenusLinks.vue?vue&type=script&lang=js"
export * from "./AdminOrdersSubMenusLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2543c05a')) {
      api.createRecord('2543c05a', component.options)
    } else {
      api.reload('2543c05a', component.options)
    }
    module.hot.accept("./AdminOrdersSubMenusLinks.vue?vue&type=template&id=2543c05a", function () {
      api.rerender('2543c05a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/sub-menus/orders/AdminOrdersSubMenusLinks.vue"
export default component.exports